import { parseResponse } from "../helper";
import { baseApi } from "../redux/baseAPI";

export const patientApi = baseApi.injectEndpoints({
  tagTypes: ["Patient", "PatientDemographics", "PatientGroups"],
  endpoints: (builder) => ({
    getPatient: builder.query({
      query: (patientId) => {
        if (patientId) {
          return {
            url: `/demographics/patient_summary.json`,
            method: "GET",
            params: { pid: patientId },
          };
        }
      },
      transformResponse: (response, meta, arg) => {
        let tempResponse = response?.response?.data;
        if (tempResponse?.Patient?.sex) {
          tempResponse.Patient.sex = tempResponse?.Patient?.sex.toString().toLowerCase();
        }
        return tempResponse;
      },
      providesTags: ["Patient"],
    }),
    getPatientDemographics: builder.query({
      query: (patientId) => {
        if (patientId) {
          return {
            url: `/demographics.json`,
            method: "GET",
            params: { pid: patientId },
          };
        }
      },
      transformResponse: (response, meta, arg) => {
        let tempResponse = response?.response?.data;
        if (tempResponse?.Patient?.sex) {
          tempResponse.Patient.sex = tempResponse?.Patient?.sex.toString().toLowerCase();
        }
        return tempResponse;
      },
      providesTags: ["PatientDemographics"],
    }),
    getPatientColorGroups: builder.query({
      query: (params = {}) => {
        return {
          url: `/PatientColorGroup/index.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
      providesTags: ["PatientGroups"],
    }),
    savePatientGroup: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (data) => {
        return {
          url: `/PatientColorGroup/add_patient_color_groups.json`,
          method: "POST",
          data: data,
        }
      },
      transformResponse: (response, meta, arg) => response,
      invalidatesTags: ["PatientGroups"],
    }),
  }),
});

export const { 
  useGetPatientQuery, 
  useGetPatientDemographicsQuery,
  useGetPatientColorGroupsQuery,
  useSavePatientGroupMutation 
} = patientApi;
